import Moment from 'moment';

export const formatDateTime = (s: string | Date, format?: string) =>
  Moment(s).format(format || 'MM/DD/YYYY');
